export default {
  name: "SmartMenuPropMixin",

  data() {
    return {
      //dependent on "menuOpen" in data from implementation source
      openAbove: false,
      maxMenuHeight: 300,
    };
  },

  methods: {
    repositionMenu() {
      const ac = this.$refs.QPaginatedSearchDropdown
      const menu = ac && ac.$refs && ac.$refs.menu
      if (menu && menu.updateDimensions) {
        menu.updateDimensions()
      }

      /*
      //scroll to top
      const content = menu && menu.$refs && menu.$refs.content
      if (content) {
        content.scrollTop = 0
      }
      */
    },
    
    updateMenuPlacement() {
      const acEl = this.$refs.QPaginatedSearchDropdown?.$el
      if (!acEl) return

      const rect = acEl.getBoundingClientRect()
      const viewportH = window.innerHeight
      const spaceBelow = viewportH - rect.bottom
      const spaceAbove = rect.top

      // if not enough room below for menu height, prefer opening above
      this.openAbove =
        spaceBelow < this.maxMenuHeight && spaceAbove > spaceBelow
    },
  },

  computed: {
    menuProps() {
      return {
        top: this.openAbove,          // flip direction manually
        attach: this.$el,             // keep scroll-safe attach
        maxHeight: this.maxMenuHeight,
        offsetY: true,
        closeOnContentClick: !this.multiple,
      }
    },
  },

  watch: {
    menuOpen(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateMenuPlacement()
          this.repositionMenu()
        })
      }
    },

    'list.length'() {
      if (this.menuOpen) {
        this.$nextTick(() => {
          this.repositionMenu()
        })
      }
    },
  },
};